import http from "../httpService";
import { apiUrl } from "../../../config.js";
import { DateTime } from "luxon";

const apiEndpoint = apiUrl + "/inventory/items-movement/";
export function saveServiceTimeSheet(serviceTimeSheet) {
  return http.post(apiEndpoint + "service-timesheet", serviceTimeSheet);
}

export function saveItemsReceived(items) {
  return http.post(apiEndpoint + "receive-items", items);
}

export function saveItemsTransfer(itemsTransfer) {
  return http.post(apiEndpoint + "items-transfer", itemsTransfer);
}

export function getItemsTransfer(warehouseID = 0, outletID = 0) {
  return http.get(
    apiEndpoint + "items-transfer/" + warehouseID + "/" + outletID
  );
}

export function getTransferDetail(transferID = 0) {
  return http.get(apiEndpoint + "transfer-detail/" + transferID);
}

export function getItemsTransferRequest(
  fwarehouseID = 0,
  warehouseID = 0,
  outletID = 0
) {
  return http.get(
    apiEndpoint +
      "items-transfer-request/" +
      fwarehouseID +
      "/" +
      warehouseID +
      "/" +
      outletID
  );
}

export function cancelItemsTransfer(transferID = 0) {
  return http.delete(apiEndpoint + "cancel-items-transfer/" + transferID);
}

export function getReceivedServices(year, month, purchaseOrderItemID) {
  return http.get(
    apiEndpoint +
      "received-services/" +
      year +
      "/" +
      month +
      "/" +
      purchaseOrderItemID
  );
}

export function getReceivedItems(docRefType, docRefID, docRefItemID) {
  return http.get(
    apiEndpoint +
      "received-items/" +
      docRefType +
      "/" +
      docRefID +
      "/" +
      docRefItemID
  );
}

export function getPendingReceivedItemsTransfer(locationType, locationID) {
  return http.get(
    `${apiEndpoint}pending-received-items-transfer/${locationType}/${locationID}`
  );
}

export function getPendingReceivedItemsTransferDetail(transferID) {
  return http.get(
    `${apiEndpoint}pending-received-items-transfer-detail/${transferID}`
  );
}

export function saveUnloadedJourneyStock(stock) {
  return http.post(`${apiEndpoint}unloaded-journey-stock`, stock);
}

export function getPendingJourneyStocksTransfer(warehouseID) {
  return http.get(
    apiEndpoint + "journey-pending-stocks-transfer/" + warehouseID
  );
}

export function convertStockQtyUnit(stockUnitConv) {
  return http.post(`${apiEndpoint}convert-stock-qty-unit`, stockUnitConv);
}

export function getConversionStockQtyUnit(warehouseID) {
  return http.get(apiEndpoint + "conversion-stock-qty-unit/" + warehouseID);
}

export function getItemsMovement(
  warehouseID = 0,
  outletID = 0,
  itemID = 0,
  varCode = "",
  batchID = 0,
  fiscalYear = 0,
  fiscalPeriod = 0
) {
  if (varCode === "") {
    varCode = "-";
  }
  return http.get(
    apiEndpoint +
      `items-movement/${warehouseID}/${outletID}/${fiscalYear}/${fiscalPeriod}/${itemID}/${varCode}/${batchID}`
  );
}

export function saveItemsMovement(itemsMovement) {
  return http.post(apiEndpoint + "items-movement", itemsMovement);
}

export function getStockCounting(warehouseID = 0, outletID = 0) {
  return http.get(
    apiEndpoint + "stock-counting/" + warehouseID + "/" + outletID
  );
}

export function getStockCountingItem(stockCountingID = 0) {
  return http.get(apiEndpoint + "stock-counting-item/" + stockCountingID);
}

export function getStocksToCount(
  warehouseID = 0,
  outletID = 0,
  countDate = DateTime.now().startOf("day")
) {
  return http.get(
    apiEndpoint +
      "stocks-to-count/" +
      warehouseID +
      "/" +
      outletID +
      "/" +
      countDate.toISODate()
  );
}

export function saveStockCounting(stockCounting) {
  return http.post(apiEndpoint + "stock-counting", stockCounting);
}

export function saveItemReturn(itemReturn) {
  return http.post(apiEndpoint + "return-item", itemReturn);
}

export function uploadItemsStock(file) {
  return http.post(apiEndpoint + "upload-items-stocks", file, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function saveUploadedItemsStocks(uploadedItemsStocks) {
  return http.post(
    apiEndpoint + "save-uploaded-items-stocks",
    uploadedItemsStocks
  );
}

export function downloadItemsStockTemplate() {
  return http.get(apiEndpoint + "download-items-stock-template");
}

export function getReceivedItemsHistory(
  fiscalYear = 0,
  fiscalPeriod = 0,
  warehouseID = 0
) {
  return http.get(
    apiEndpoint +
      `received-items-history/${fiscalYear}/${fiscalPeriod}/${warehouseID}`
  );
}

export function getReceivedItemsDetail(movementID = 0) {
  return http.get(apiEndpoint + `received-items-detail/${movementID}`);
}

export function cancelItemsMovement(movementID = 0) {
  return http.delete(apiEndpoint + `cancel-items-movement/${movementID}`);
}

export function saveSalesReturnReceivedItems(itemsReturn) {
  return http.post(apiEndpoint + "sales-return-received-items", itemsReturn);
}

export function getBatches() {
  return http.get(apiEndpoint + "batches");
}
